// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Feedback Panel Styles */

.feedback-panel-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  animation: fadeIn 0.2s ease-out;
}

.feedback-panel {
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  width: 100%;
  max-width: 800px;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  animation: slideUp 0.3s ease-out;
}

.feedback-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 32px;
  border-bottom: 1px solid #e5e7eb;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.feedback-panel-title {
  display: flex;
  align-items: center;
  gap: 12px;
}

.feedback-icon {
  font-size: 24px;
}

.feedback-panel-title h2 {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
}

.feedback-close-btn {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  font-size: 24px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.feedback-close-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.05);
}

.feedback-panel-content {
  flex: 1 1;
  overflow-y: auto;
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 32px;
}

/* Form Section */
.feedback-form-section h3 {
  margin: 0 0 20px 0;
  color: #1f2937;
  font-size: 20px;
  font-weight: 600;
}

.feedback-success {
  background: #d1fae5;
  border: 1px solid #10b981;
  color: #065f46;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 20px;
  font-weight: 500;
}

.feedback-error {
  background: #fee2e2;
  border: 1px solid #ef4444;
  color: #991b1b;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 20px;
  font-weight: 500;
}

.feedback-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.feedback-form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.feedback-form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.feedback-form-group label {
  font-weight: 600;
  color: #374151;
  font-size: 14px;
}

.feedback-select,
.feedback-input {
  padding: 12px 16px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 16px;
  transition: all 0.2s ease;
  background: white;
}

.feedback-select:focus,
.feedback-input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.feedback-textarea {
  padding: 12px 16px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 16px;
  font-family: inherit;
  resize: vertical;
  min-height: 120px;
  transition: all 0.2s ease;
}

.feedback-textarea:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.feedback-char-count {
  font-size: 12px;
  color: #6b7280;
  text-align: right;
  margin-top: 4px;
}

.feedback-context-note {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 12px 16px;
  background: #f3f4f6;
  border-radius: 8px;
  font-size: 14px;
  color: #4b5563;
  line-height: 1.5;
}

.feedback-context-icon {
  font-size: 16px;
  margin-top: 1px;
}

.feedback-submit-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 16px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.2s ease;
  align-self: flex-start;
}

.feedback-submit-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.3);
}

.feedback-submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.feedback-spinner {
  animation: spin 1s linear infinite;
}

/* Recent Feedback Section */
.feedback-recent-section h3 {
  margin: 0 0 20px 0;
  color: #1f2937;
  font-size: 20px;
  font-weight: 600;
}

.feedback-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 40px;
  color: #6b7280;
  font-size: 16px;
}

.feedback-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 40px;
  color: #6b7280;
  text-align: center;
}

.feedback-empty-icon {
  font-size: 48px;
  opacity: 0.5;
}

.feedback-recent-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.feedback-recent-item {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 20px;
  transition: all 0.2s ease;
}

.feedback-recent-item:hover {
  background: #f3f4f6;
  border-color: #d1d5db;
}

.feedback-recent-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.feedback-recent-type {
  display: flex;
  align-items: center;
  gap: 8px;
}

.feedback-type-icon {
  font-size: 18px;
}

.feedback-type-text {
  font-weight: 600;
  color: #374151;
  font-size: 14px;
}

.feedback-recent-meta {
  display: flex;
  align-items: center;
  gap: 8px;
}

.feedback-priority-badge,
.feedback-status-badge {
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  color: white;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.feedback-recent-title {
  font-weight: 600;
  color: #1f2937;
  font-size: 16px;
  margin-bottom: 8px;
  line-height: 1.4;
}

.feedback-recent-date {
  font-size: 14px;
  color: #6b7280;
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .feedback-panel-overlay {
    padding: 10px;
  }

  .feedback-panel {
    max-height: 95vh;
  }

  .feedback-panel-header {
    padding: 20px 24px;
  }

  .feedback-panel-title h2 {
    font-size: 20px;
  }

  .feedback-panel-content {
    padding: 24px;
    gap: 24px;
  }

  .feedback-form-row {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .feedback-recent-item {
    padding: 16px;
  }

  .feedback-recent-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .feedback-recent-meta {
    align-self: flex-end;
  }
}

@media (max-width: 480px) {
  .feedback-panel-header {
    padding: 16px 20px;
  }

  .feedback-panel-content {
    padding: 20px;
  }

  .feedback-submit-btn {
    width: 100%;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/FeedbackPanel.css"],"names":[],"mappings":"AAAA,0BAA0B;;AAE1B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;EAC3C,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;EAChC,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,eAAe;AACf;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/* Feedback Panel Styles */\n\n.feedback-panel-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(4px);\n  z-index: 10000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  animation: fadeIn 0.2s ease-out;\n}\n\n.feedback-panel {\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);\n  width: 100%;\n  max-width: 800px;\n  max-height: 90vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  animation: slideUp 0.3s ease-out;\n}\n\n.feedback-panel-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 24px 32px;\n  border-bottom: 1px solid #e5e7eb;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n}\n\n.feedback-panel-title {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.feedback-icon {\n  font-size: 24px;\n}\n\n.feedback-panel-title h2 {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 600;\n}\n\n.feedback-close-btn {\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n  color: white;\n  font-size: 24px;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.feedback-close-btn:hover {\n  background: rgba(255, 255, 255, 0.3);\n  transform: scale(1.05);\n}\n\n.feedback-panel-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 32px;\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n}\n\n/* Form Section */\n.feedback-form-section h3 {\n  margin: 0 0 20px 0;\n  color: #1f2937;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.feedback-success {\n  background: #d1fae5;\n  border: 1px solid #10b981;\n  color: #065f46;\n  padding: 16px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  font-weight: 500;\n}\n\n.feedback-error {\n  background: #fee2e2;\n  border: 1px solid #ef4444;\n  color: #991b1b;\n  padding: 16px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  font-weight: 500;\n}\n\n.feedback-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.feedback-form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n}\n\n.feedback-form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.feedback-form-group label {\n  font-weight: 600;\n  color: #374151;\n  font-size: 14px;\n}\n\n.feedback-select,\n.feedback-input {\n  padding: 12px 16px;\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n  font-size: 16px;\n  transition: all 0.2s ease;\n  background: white;\n}\n\n.feedback-select:focus,\n.feedback-input:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.feedback-textarea {\n  padding: 12px 16px;\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n  font-size: 16px;\n  font-family: inherit;\n  resize: vertical;\n  min-height: 120px;\n  transition: all 0.2s ease;\n}\n\n.feedback-textarea:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.feedback-char-count {\n  font-size: 12px;\n  color: #6b7280;\n  text-align: right;\n  margin-top: 4px;\n}\n\n.feedback-context-note {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 12px 16px;\n  background: #f3f4f6;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #4b5563;\n  line-height: 1.5;\n}\n\n.feedback-context-icon {\n  font-size: 16px;\n  margin-top: 1px;\n}\n\n.feedback-submit-btn {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  padding: 16px 24px;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  transition: all 0.2s ease;\n  align-self: flex-start;\n}\n\n.feedback-submit-btn:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.3);\n}\n\n.feedback-submit-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.feedback-spinner {\n  animation: spin 1s linear infinite;\n}\n\n/* Recent Feedback Section */\n.feedback-recent-section h3 {\n  margin: 0 0 20px 0;\n  color: #1f2937;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.feedback-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 40px;\n  color: #6b7280;\n  font-size: 16px;\n}\n\n.feedback-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 40px;\n  color: #6b7280;\n  text-align: center;\n}\n\n.feedback-empty-icon {\n  font-size: 48px;\n  opacity: 0.5;\n}\n\n.feedback-recent-list {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.feedback-recent-item {\n  background: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  padding: 20px;\n  transition: all 0.2s ease;\n}\n\n.feedback-recent-item:hover {\n  background: #f3f4f6;\n  border-color: #d1d5db;\n}\n\n.feedback-recent-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n\n.feedback-recent-type {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.feedback-type-icon {\n  font-size: 18px;\n}\n\n.feedback-type-text {\n  font-weight: 600;\n  color: #374151;\n  font-size: 14px;\n}\n\n.feedback-recent-meta {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.feedback-priority-badge,\n.feedback-status-badge {\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 600;\n  color: white;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.feedback-recent-title {\n  font-weight: 600;\n  color: #1f2937;\n  font-size: 16px;\n  margin-bottom: 8px;\n  line-height: 1.4;\n}\n\n.feedback-recent-date {\n  font-size: 14px;\n  color: #6b7280;\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Mobile Responsive */\n@media (max-width: 768px) {\n  .feedback-panel-overlay {\n    padding: 10px;\n  }\n\n  .feedback-panel {\n    max-height: 95vh;\n  }\n\n  .feedback-panel-header {\n    padding: 20px 24px;\n  }\n\n  .feedback-panel-title h2 {\n    font-size: 20px;\n  }\n\n  .feedback-panel-content {\n    padding: 24px;\n    gap: 24px;\n  }\n\n  .feedback-form-row {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n\n  .feedback-recent-item {\n    padding: 16px;\n  }\n\n  .feedback-recent-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n\n  .feedback-recent-meta {\n    align-self: flex-end;\n  }\n}\n\n@media (max-width: 480px) {\n  .feedback-panel-header {\n    padding: 16px 20px;\n  }\n\n  .feedback-panel-content {\n    padding: 20px;\n  }\n\n  .feedback-submit-btn {\n    width: 100%;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
